<template>
  <div ref="announcement" class="announcement-w">
    <div ref="head" class="head" :style="{ top: announcementScrollTop + 'px' }">
      <div class="title d_flex align_item_c">
        <img class="img_1" src="../assets/images/bigdata_1.png" alt="">
        <span class="fz20">成交公示</span>
      </div>
    </div>

    <div
      ref="data_c"
      class="data-c-w"
      :style="{ 'padding-top': headHeight + 'px' }"
    >
      <SeamlessScroll
        :list="noticeData"
      >
        <template v-slot:scrollInner="{item}">
          <div class="c-row c-item">
            <router-link :to="`cms/info/${item.id}`" target="_blank" class="div_1 cursor_pointer title fz16 text_ellipsis">{{ item.title }}</router-link>
            <div class="created-date fz14">发布时间：{{ item.createdAt }}</div>
          </div>
        </template>
      </SeamlessScroll>
    </div>

  </div>
</template>

<script>
import { data_notice } from '@/api/portal'
import { mapGetters } from 'vuex'

import SeamlessScroll from '@/components/base/SeamlessScroll.vue'

export default {
  components: {
    SeamlessScroll
  },

  data() {
    return {
      announcementScrollTop: -3,
      headHeight: 0,

      noticeData: [], // 公告列表

      refreshTime: null, // 列表刷新定时器
      rows: 30 // 查询列表条数

    }
  },
  computed: {
    ...mapGetters(['siteInfo'])

  },
  watch: {
    siteInfo:{
      handler(n){
        if(Object.keys(n).length){
          this.getNoticeData()
          this.$nextTick(() => {
            this.headHeight = this.$refs.head.offsetHeight
          })
        }
      },
      immediate:true,
      deep:true
    }
  },
  created() {

  },
  mounted() {

  },
  destroyed() {
    clearInterval(this.refreshTime) // 刷新列表定时器
  },
  methods: {

    // 获取公告数据 api
    async getNoticeData(params) {
      const { data } = await data_notice(params || { kind: 'cnotice', rows: this.rows })
      this.noticeData = data.list
      this.setRefreshCountDown()
    },

    // 设置刷新倒计时（每3分钟刷新一次）
    async setRefreshCountDown() {
      this.refreshTime && clearInterval(this.refreshTime)
      this.refreshTime = setInterval(async() => {
        this.getNoticeData()
      }, 1000 * 60 * 3)
    }

  }
}
</script>

<style lang="scss" scoped>
.v-enter,
.v-leave-to {
  opacity: 0;
}
.v-enter-active,
.v-leave-active {
  transition: opacity 1s;
}

.announcement-w {
  overflow: hidden;
  width: 374px;
  position: relative;
  height: 100%;

  &::-webkit-scrollbar {
    display: none;
  }
  & {
    scrollbar-width: none; //火狐
  }
  & > .head {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    background: url("../assets/images/bigdata_5.png") 0 100% / contain no-repeat;

    .title {
      padding: 9px 0 9px 16px;

      font-weight: bold;
      font-size: 22px;
      letter-spacing: 2px;
      color: #fff;
    }
  }

  & > .data-c-w {
    overflow: hidden;
    height: 895px;
    background-color: rgba($color: #343265, $alpha: 0.5);
    .c-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0;
    }
    .c-item {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      color: #fff;
      font-size: 14px;

      padding: 29px 10px 20px 28px;
      .title {
        position: relative;
        font-weight: bold;
        letter-spacing: 2px;
        &::before {
          content: "";
          position: absolute;
          left: -12px;
          top: 3px;
          width: 8px;
          height: 8px;
          background: #fff;
          border-radius: 50%;
        }
      }
      .created-date {
        margin-top: 9px;
        color: rgba($color: #fff, $alpha: 0.7);
      }
    }
  }
  .img_1 {
    width: 18px;
    height: 18px;
    margin: 0 7px 0 0;
  }
  .div_1{
    max-width: 320px;
    &:hover{
      text-decoration: underline;
    }
  }
}
</style>
